import { Link } from "react-router-dom";
import backArrowIcon from "../../assets/img/back-arrow.png";
import { API_URL } from "../../utils/constant";
import axios from "axios";
import { useEffect, useState } from "react";
import { useForm } from "../../hooks/useForm";
import { useAuth } from "../../routers/AuthProvider";
import useGetPermission from "../../hooks/useGetPermission";
import AccessDeniedPage from "../AccessDeniedPage";

const actionColors = {
  View: "text-green-500",
  Write: "text-blue-500",
  Edit: "text-yellow-500",
  Delete: "text-red-500",
};

export default function UserPermission() {
  const backPath = `/office-user/user-permission`;
  const { handleInputChange, formData, setFormData, submitForm, setError, error } =
    useForm();

  const { hasAccess } = useGetPermission();

  const { user, loading, setLoading } = useAuth();
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(true);
  const [permissionsLoading, setPermissionsLoading] = useState(true);

  const loadRoles = async () => {
    setRolesLoading(true);
    try {
      const response = await axios.get(
        API_URL + "/role?included=true&sort=role_level",
        {
          withCredentials: true,
        }
      );
      setRoles(response.data.data);
    } catch (e) {
      setRoles([]);
    } finally {
      setRolesLoading(false);
    }
  };

  const loadPermissions = async () => {
    setPermissionsLoading(true);
    try {
      const response = await axios.get(API_URL + "/common/module-list", {
        withCredentials: true,
      });
      const fetchedModules = response.data.data;
      const formattedPermissions = fetchedModules.map((module) => ({
        ...module,
        sub_modules: module.sub_modules.map((sub) => ({
          ...sub,
          view: sub.view || false,
          write: sub.write || false,
          edit: sub.edit || false,
          delete: sub.delete || false,
        })),
      }));
      setPermissions(formattedPermissions);
    } catch (e) {
      setPermissions([]);
    } finally {
      setPermissionsLoading(false);
    }
  };

  useEffect(() => {
    loadRoles();
  }, []);

  useEffect(() => {
    loadPermissions();
  }, []);

  const togglePermission = (moduleIdx, subIdx, action) => {
    const updated = [...permissions];
    updated[moduleIdx].sub_modules[subIdx][action] =
      !updated[moduleIdx].sub_modules[subIdx][action];
    setPermissions(updated);
  };
  const toggleModulePermission = (moduleIdx, checked) => {
    const updated = [...permissions];
    updated[moduleIdx].sub_modules = updated[moduleIdx].sub_modules.map(
      (sub) => ({
        ...sub,
        view: checked,
        write: checked,
        edit: checked,
        delete: checked,
      })
    );
    setPermissions(updated);
  };

  const clearPermissions = () => {
    setPermissions((currentPermissions) =>
      currentPermissions.map((module) => ({
        ...module,
        sub_modules: module.sub_modules.map((sub) => ({
          ...sub,
          view: false,
          write: false,
          edit: false,
          delete: false,
        })),
      }))
    );
  };

  const handleCancel = () => {
    if (loading) return;
    setFormData((prev) => ({
      ...prev,
      role_id: "",
    }));
    clearPermissions();
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    const formattedPermissions = permissions.flatMap((module) =>
      module.sub_modules.map((sub) => ({
        module_id: module.id,
        sub_module_id: sub.sub_module_id,
        view: sub.view,
        write: sub.write,
        edit: sub.edit,
        delete: sub.delete,
      }))
    );

    const data = {
      role_id: formData?.role_id,
      permissions: formattedPermissions,
    };
    submitForm("POST", "/userPermission/create", data, async () => {
      await Promise.all([loadRoles(), loadPermissions()]);
      setFormData((prev) => ({
        ...prev,
        role_id: "",
      }));
    });
  };
  return (
    <>
      <div className="sub-page-layout-1">
        {/*<Link className="back-to-page" to={backPath}>
          <img src={backArrowIcon} />
          Back
        </Link>*/}
        <div className="container" style={{ height: "auto" }}>
          <h1 className="sub-page-title">User Permission</h1>
          {hasAccess("view", "Office User", "User Permission") ? (
            <div className="form-container">
              <form
                onSubmit={onSubmit}
                className="form flex flex-col justify-between w-full"
              >
                <div className="grid grid-cols-2 gap-9">
                  <div className="grow">
                    <label className="x-label">User Role</label>
                    <div className="dd-container">
                      <select
                        type="text"
                        required
                        name="role_id"
                        disabled={
                          rolesLoading ||
                          !hasAccess("edit", "Office User", "User Permission")
                        }
                        onChange={(e) => {
                          handleInputChange(e);
                          const selectedRoleId = e.target.value;
                          const selectedRole = roles.find(
                            (r) => r.role_id == selectedRoleId
                          );

                          if (
                            selectedRole &&
                            selectedRole.permissions?.length
                          ) {
                            const updatedPermissions = permissions.map(
                              (module) => {
                                const moduleWithSubs = {
                                  ...module,
                                  sub_modules: module.sub_modules.map((sub) => {
                                    // Match permission based on sub_module_id (including null)
                                    const matched =
                                      selectedRole.permissions.find((p) =>
                                        sub.sub_module_id == null
                                          ? p.module_id == module.id &&
                                            p.sub_module_id == null
                                          : p.sub_module_id == sub.sub_module_id
                                      );

                                    return {
                                      ...sub,
                                      view: matched?.view == 1,
                                      write: matched?.write == 1,
                                      edit: matched?.edit == 1,
                                      delete: matched?.delete == 1,
                                    };
                                  }),
                                };
                                return moduleWithSubs;
                              }
                            );

                            setPermissions(updatedPermissions);
                          } else {
                            clearPermissions();
                          }
                        }}
                        value={formData?.role_id ?? ""}
                        className="x-input dropdown"
                      >
                        <option value="" disabled>
                          {rolesLoading ? "Loading roles..." : "Select"}
                        </option>
                        {!rolesLoading &&
                          roles.map((role) => (
                            <option key={role.role_id} value={role.role_id}>
                              {role.role_name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className=" p-4 space-y-8 h-[600px] overflow-y-auto">
                  {permissions.map((module, moduleIdx) => (
                    <div key={moduleIdx} className="border rounded-lg shadow">
                      {/* <div className="flex items-center bg-gray-100 p-4 border-b">
                      <h2 className="font-semibold text-lg">
                        {module.module_name}
                      </h2>
                    </div> */}

                      <div className="flex items-center gap-3 bg-gray-100 p-4 border-b">
                        <input
                          type="checkbox"
                          onChange={(e) =>
                            toggleModulePermission(moduleIdx, e.target.checked)
                          }
                          checked={module.sub_modules.every(
                            (sub) =>
                              sub.view && sub.write && sub.edit && sub.delete
                          )}
                        />
                        <h2 className="font-semibold text-lg">
                          {module.module_name}
                        </h2>
                      </div>
                      {module.sub_modules.map((sub, subIdx) => (
                        <div
                          key={subIdx}
                          className="flex items-center justify-between p-4 border-b hover:bg-gray-50"
                        >
                          <div className="flex items-center">
                            <span>
                              {sub.sub_module_name || module.module_name}
                            </span>
                          </div>
                          <div className="flex gap-4">
                            {["view", "write", "edit", "delete"].map(
                              (action) => (
                                <label
                                  key={action}
                                  className="flex items-center gap-1"
                                >
                                  <input
                                    type="checkbox"
                                    checked={sub[action]}
                                    onChange={() =>
                                      togglePermission(
                                        moduleIdx,
                                        subIdx,
                                        action
                                      )
                                    }
                                  />
                                  <span
                                    className={`text-sm ${
                                      actionColors[
                                        action.charAt(0).toUpperCase() +
                                          action.slice(1)
                                      ]
                                    }`}
                                  >
                                    {action.charAt(0).toUpperCase() +
                                      action.slice(1)}
                                  </span>
                                </label>
                              )
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                <div className="form-btn-group">
                  {/* {error ? (
                  <span className="w-full block text-lg text-red-500 text-right">
                    {error}
                  </span>
                ) : (
                  ""
                )} */}
                  <div className="flex justify-end gap-5 mt-5">
                    <button
                      type="button"
                      className="white-btn"
                      onClick={handleCancel}
                      disabled={loading}
                      style={loading ? { opacity: 0.6, cursor: "not-allowed" } : undefined}
                    >
                      Cancel
                    </button>
                    {hasAccess("write", "Office User", "User Permission") && (
                      <button className="gold-btn" disabled={loading}>
                        {loading ? "Creating..." : "Create"}
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          ) : (
            <AccessDeniedPage />
          )}
        </div>
      </div>
    </>
  );
}
